import { render, staticRenderFns } from "./UserRolesTable.vue?vue&type=template&id=6f29ffa2&"
import script from "./UserRolesTable.vue?vue&type=script&lang=js&"
export * from "./UserRolesTable.vue?vue&type=script&lang=js&"
import style0 from "./UserRolesTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports